import $ from 'jquery';
import debug from 'bows';
import { TweenLite } from 'gsap';

const log = debug('wdg:VerticalSlideshow');

class WdgVerticalSlideshow {
	constructor(options = {}) {
		this.defaults = {
			container: null,
			slideshowContainer: null,
			cellSelector: '.slideshow__slide',
			slideshowContainerSelector: '.slideshow__slides',
			animationSpeed: 0.75
		};

		options = $.extend({}, this.defaults, options);
		this.options = options;
		log(options);

		this.container = options.container;
		this.$container = $(options.container);
		this.slideshowContainerSelector = options.slideshowContainerSelector;
		this.$slideshowContainer = this.$container.find(options.slideshowContainerSelector);
		this.slideshowContainer = this.$slideshowContainer[0];
		this.cellSelector = options.cellSelector;
		this.$slides = this.$container.find(options.cellSelector);
		this.slides = this.$slides.toArray();
		this.currentIndex = 0;

		this.init();
	}

	init() {
		log(this.$container);
		if (!this.$slideshowContainer.length || this.$slides.length <= 1) {
			log('init:skipped', {
				$container: this.$container,
				$slideshowContainer: this.$slideshowContainer,
				$slides: this.$slides
			});
			return;
		}

		log('init:start', {
			container: this.container,
			slideshowContainer: this.slideshowContainer,
			cellSelector: this.cellSelector,
			slides: this.slides
		});

		this.buttonEvents();
		this.buttonStates();
		this.renderFirst();
		this.$container.addClass('is-active');

		log('init:end');
	}

	buttonStates() {
		const length = this.$slides.length;
		const index = this.currentIndex;
		const $prev = this.$container.find('.js-prev');
		const $next = this.$container.find('.js-next');

		$prev.toggleClass('is-disabled', index === 0);
		$next.toggleClass('is-disabled', index === (length - 1));
	}

	buttonEvents() {
		log('buttonevents');
		this.$container.on('click', '.js-prev:not([disabled])', (e) => {
			log('prev');
			e.preventDefault();
			this.previous();
		});

		this.$container.on('click', '.js-next:not([disabled])', (e) => {
			log('next');
			e.preventDefault();
			this.next();
		});
	}

	previous() {
		const { currentIndex } = this;

		if (currentIndex === 0) {
			return;
		}

		const newIndex = currentIndex - 1;
		const $curItem = this.$slides.eq(currentIndex);
		const $newItem = this.$slides.eq(newIndex);
		const curHeight = $curItem.height();
		const newHeight = $newItem.height();
		const { animationSpeed } = this.options;

		$curItem.removeClass('is-active');
		$newItem.addClass('is-active');

		TweenLite.to(this.$slideshowContainer, animationSpeed, { height: newHeight });
		TweenLite.fromTo($curItem, animationSpeed, { y: 0 }, { y: newHeight });
		TweenLite.fromTo($newItem, animationSpeed, { y: -newHeight }, { y: 0 });

		this.currentIndex--;
		this.buttonStates();
	}

	next() {
		const { currentIndex } = this;

		if (currentIndex === (this.$slides.length - 1)) {
			return;
		}

		const newIndex = currentIndex + 1;
		const $curItem = this.$slides.eq(currentIndex);
		const $newItem = this.$slides.eq(newIndex);
		const curHeight = $curItem.height();
		const newHeight = $newItem.height();
		const { animationSpeed } = this.options;

		$curItem.removeClass('is-active');
		$newItem.addClass('is-active');

		TweenLite.to(this.$slideshowContainer, animationSpeed, { height: newHeight });
		TweenLite.fromTo($curItem, animationSpeed, { y: 0 }, { y: -curHeight });
		TweenLite.fromTo($newItem, animationSpeed, { y: newHeight }, { y: 0 });

		this.currentIndex++;
		this.buttonStates();
	}

	renderFirst() {
		const { currentIndex } = this;
		const $curItem = this.$slides.eq(currentIndex);
		const height = $curItem.height();
		$curItem.addClass('is-active');
		this.$slideshowContainer.css({ height });
	}
}

export default WdgVerticalSlideshow;
